import { NAME } from './constants';
import { router } from './router';

export const WmsWashingLabor = {
	name: NAME,
	router,
};
